import React from "react";
import styled from "@emotion/styled";
import withTranslator from "../Translator/withTranslation";

const CLEAR_ICON_POSITION = '0.75rem';

const ClearButton = styled.button`
    right:${( {relative, offsetRight } ) => {
        let right = relative ? '0' : offsetRight;
        return `${right}`;
    }};    
`;

const SelectClearButtonComponent = (props) => {
    const clear = () => {
        props.onChange(null);
    }

    if(!props.clearable || !props.value) {
        return null;
    }

    const { t } = props;

    return(
        <ClearButton
        title={t('clear')}
        onClick={clear}
        type="button"
        offsetRight={props.offsetRight ? props.offsetRight : CLEAR_ICON_POSITION}
        relative={props.relative}
        className={(!props.relative ? "absolute pad-no " : "") + (props.className ? props.className : " btn-no bg-no mar-no bor-no font-120")}>&times;</ClearButton>
    );
}

export const SelectClearButton = withTranslator(SelectClearButtonComponent);
